import { render, staticRenderFns } from "./TxZoomBlocker.vue?vue&type=template&id=f19f5bea&scoped=true&"
import script from "./TxZoomBlocker.vue?vue&type=script&lang=js&"
export * from "./TxZoomBlocker.vue?vue&type=script&lang=js&"
import style0 from "./TxZoomBlocker.vue?vue&type=style&index=0&id=f19f5bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19f5bea",
  null
  
)

export default component.exports